import mapLayers from "./maplayers";

const en = {
	mapLayers
};

export default en;
export { en };
